import React from 'react'
import { arrayOf, bool, object } from 'prop-types'
import {
  HeroBrindes,
  BrindesGrid,
  BrindeCard,
  BrindeFoto,
  BrindeVazio,
  BrindeLegenda,
  StatKey
} from './styles'

export default function Brindes( { brindes, isReativacao } ) {
  if ( !brindes.length ) {
    return null
  }

  const acao = isReativacao ? 'reativar' : 'renovar'
  const rotulo = `Brindes que você garante ao ${acao}`

  return (
    <HeroBrindes>
      <StatKey>{ rotulo }</StatKey>
      <BrindesGrid $unico={ brindes.length === 1 }>
        { brindes.map( ( brinde ) => (
          <BrindeCard key={ brinde.id }>
            <BrindeFoto>
              { brinde.imagem ? (
                <img
                  alt={ brinde.alt }
                  src={ brinde.imagem }
                />
              ) : (
                <BrindeVazio>Imagem em breve</BrindeVazio>
              ) }
            </BrindeFoto>
            <BrindeLegenda>{ brinde.nome }</BrindeLegenda>
          </BrindeCard>
        ) ) }
      </BrindesGrid>
    </HeroBrindes>
  )
}

Brindes.propTypes = {
  'brindes': arrayOf( object ),
  'isReativacao': bool
}

Brindes.defaultProps = {
  'brindes': [],
  'isReativacao': false
}
